'use client'
import type { FC, ReactNode } from 'react'
import { customTheme } from '#/src/custom/styles/theme'
import { ChakraProvider } from '@chakra-ui/react'
import { EmotionRegistry } from 'ui/lib/emotion-registry/EmotionRegistry'

interface ChakraProviderNextProps {
  children: ReactNode
}

const ChakraProviderNext: FC<ChakraProviderNextProps> = ({ children }) => {
  return (
    <EmotionRegistry>
      <ChakraProvider resetCSS theme={customTheme}>
        {children}
      </ChakraProvider>
    </EmotionRegistry>
  )
}

export default ChakraProviderNext
